/**
 * Report zoom control — shared cho mọi dashboard report (Commercial Position,
 * Futures Position, Risk, Long-Short, Inventory, Cashflows).
 *
 * Trả về `zoom` (áp CSS `zoom` lên container nội dung report — reflow đúng, KHÔNG
 * transform: scale) + `control` (cụm nút Zoom out / % reset / Zoom in compact,
 * style đồng bộ thanh công cụ, cao 24px nên KHÔNG làm block header cao hơn nút
 * Reload). State session — reset 100% khi reload trang.
 */
import ZoomInIcon from '@mui/icons-material/ZoomIn'
import ZoomOutIcon from '@mui/icons-material/ZoomOut'
import { Box, IconButton, Stack, Tooltip } from '@mui/material'
import { useState } from 'react'

const ZOOM_MIN = 0.5
const ZOOM_MAX = 1.5

export function useReportZoom() {
  const [zoom, setZoom] = useState(1)
  const zoomOut = () => setZoom((z) => Math.max(ZOOM_MIN, Math.round((z - 0.1) * 10) / 10))
  const zoomIn = () => setZoom((z) => Math.min(ZOOM_MAX, Math.round((z + 0.1) * 10) / 10))

  const control = (
    <Stack direction="row" alignItems="center" spacing={0} sx={{ height: 24, bgcolor: 'transparent' }}>
      <Tooltip title="Zoom out">
        <span style={{ display: 'inline-flex' }}>
          <IconButton
            onClick={zoomOut}
            disabled={zoom <= ZOOM_MIN}
            aria-label="Zoom out"
            sx={{ p: 0, width: 22, height: 22, bgcolor: 'transparent', '&:hover': { bgcolor: 'transparent' } }}
          >
            <ZoomOutIcon sx={{ fontSize: 16 }} />
          </IconButton>
        </span>
      </Tooltip>
      <Tooltip title="Reset zoom (100%)">
        <Box
          component="button"
          onClick={() => setZoom(1)}
          sx={{
            border: 'none', appearance: 'none', WebkitAppearance: 'none', boxShadow: 'none',
            cursor: 'pointer', p: 0, lineHeight: 1, outline: 'none',
            minWidth: 28, fontSize: '0.56rem', fontWeight: 600, color: 'text.secondary',
            '&, &:hover, &:focus, &:focus-visible, &:active': {
              background: 'transparent !important', backgroundColor: 'transparent !important',
            },
          }}
        >
          {Math.round(zoom * 100)}%
        </Box>
      </Tooltip>
      <Tooltip title="Zoom in">
        <span style={{ display: 'inline-flex' }}>
          <IconButton
            onClick={zoomIn}
            disabled={zoom >= ZOOM_MAX}
            aria-label="Zoom in"
            sx={{ p: 0, width: 22, height: 22, bgcolor: 'transparent', '&:hover': { bgcolor: 'transparent' } }}
          >
            <ZoomInIcon sx={{ fontSize: 16 }} />
          </IconButton>
        </span>
      </Tooltip>
    </Stack>
  )

  return { zoom, control }
}
